<template>
  <div class="footer-box">
    <template v-if="PROCESS_ENV.NODE_PLA === 'kby'">
      <!-- <a href="https://ori.cjton.com/agreement.html" target="_blank">《创知汇用户协议》</a>
      <a href="https://ori.cjton.com/privacy.html" target="_blank">《创知汇隐私策略》</a>  -->
      Copyright 2024 深圳市创界通科技有限公司. All Rights Reserved.
      <a href="http://beian.miit.gov.cn/" target="_blank">粤ICP备2024268789号-1</a>
    </template>
    <template v-if="PROCESS_ENV.NODE_PLA === 'wg'">
      <a :href="htmlUrl + 'agreementwg.html'" target="_blank">《盛骁科技用户协议》</a>
      <a :href="htmlUrl + 'privacyagreementwg.html'" target="_blank">《盛骁科技隐私政策》</a>
      <!-- ICP证:<a href="http://beian.miit.gov.cn/" target="_blank">粤ICP备20016192号</a> Copyright @ 2020 辰知云 -->
    </template>
  </div>
</template>
<script>
export default {
  methods: {},
  computed: {
    htmlUrl() {
      let url = this.wgUrl;
      url = url.replace('/client/', '/');
      return url;
    },
  },
};
</script>
<style lang="less" scoped>
.footer-box {
  width: 100%;
  height: 54px;
  text-align: center;
  line-height: 54px;
  font-size: 14px;
  color: #2e2e2e;
  margin-top: 46px;
  position: relative;
  z-index: 1003;
  a {
    color: #2e2e2e;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/common/otherFooter.vue